import { z } from "zod";
import { tKey } from "./messages";

export const emailField = z
  .string()
  .min(1, tKey("PLEASE_ENTER_EMAIL"))
  .pipe(z.email(tKey("VALIDATION_INVALID_EMAIL")));

export const passwordField = z.string().min(1, tKey("PASSWORD_REQUIRED"));

export const usernameField = z
  .string()
  .min(1, tKey("USERNAME_REQUIRED"))
  .min(3, tKey("USERNAME_TOO_SHORT"))
  .regex(/^[a-zA-Z0-9_]+$/, tKey("USERNAME_INVALID_CHARACTERS"));
